import { ReactComponent as Logo } from "../../../assets/tronog-logo.svg";

interface IProps {
  className?: string;
}
export default function MetailLogo({ className }: IProps) {
  return <Logo className={className} />;
}
